// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import util from '../../../../share/util/utils';
import loading from '../../../../share/components/vue/ProcessingIcon';
import config from '../../../../share/config';


export default {
  name: "specialFeatureEcuTable",
  data() {
    return {
      processing: false,
      dtcListItems: [],
      isLangRu: false,
    };
  },

  watch: {
    language: {
      immediate: true,
      handler(val) {
        this.updateDTCTable();
        // ロシア語の場合、文字サイズを小さくする
        this.isLangRu = val === "ru"? true : false;
      }
    },
  },

  components: {
    'processing-view': loading,
  },

  methods: {
    ...mapActions('auth', ['logout']),


    /**
     * クリックしたItemの処理を行う
     * @param {object} systemId 選択したシステムID
     */
    clickItem(systemId) {
      this.$router.push({
        name: "specialFeatureSelect",
        params: {
          systemId: systemId
        },
        query: {
          sameSystemFlg: false
        }
      });
      // 画面上部へのアンカースクロール
      document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant'});
    },

    /**
     * ECU一覧のリストを更新する
     */
    updateDTCTable: function () {
      if (!this.individualMenus || !this.individualMenus.menu_list) {
        return;
      }
      // メニューサポートからシステムリストを取得
      const ecuArray = this.individualMenus.menu_list.map((item) => item.system_name);
      const menuList = this.individualMenus.menu_list;
      this.dtcListItems = ecuArray.filter(ecu => {
        const targetMenu = menuList.find(menu => menu.system_name === ecu);
        return targetMenu && targetMenu.menu_display_config && this.isMenuDisplayConfig(targetMenu);
      }).map(filterEcu => {
        return {
          name: this.$t(`diagSytem.${filterEcu}`),
          systemId: filterEcu
        };
      });
      // システム名でソートを行う
      this.dtcListItems = util.sortItems(this.dtcListItems, 'name', config.ASC);
    },
    /**
     * メニューサポートのシステムリスト表示判定
     * @param {*} targetMenu targetMenu
     * @returns 表示有無
     */
    isMenuDisplayConfig(targetMenu) {
      return (targetMenu.special_feature_menu_display_config && targetMenu.special_feature_menu_display_config['diag_code'])
        || (targetMenu.menu_display_config && targetMenu.menu_display_config['vehicle_control_history'])
        || targetMenu.menu_display_config['work_support']
        || targetMenu.menu_display_config['data_monitor']
        || (targetMenu.special_feature_menu_display_config && targetMenu.special_feature_menu_display_config['cancel_code']);
    }
  },

  computed: {

    ...mapState({
      language: state => state.systems.language,
      individualMenus: state => state.vehicle.individualMenus,
    }),
  },

  created() {
  },

  mounted() {
    // ツリーから特殊機能一覧または特殊機能ノードが選択されて遷移してきた時は、特殊機能一覧ページにリダイレクトする
    if (this.$route.query && Object.prototype.hasOwnProperty.call(this.$route.query, 'systemId')) {
      const info = {
        name: 'specialFeatureSelect',
        params: {
          systemId: this.$route.query.systemId,
        }
      };

      // funcId が query に入っている場合は query に付け、リダイレクト先で更にリダイレクトし、各特殊機能ページまで遷移する
      // パンくず反映のため、瞬間的なページ遷移を行っている
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'funcId')) {
        info.query = {
          funcId: this.$route.query.funcId,
          sameSystemFlg: this.$route.query.sameSystemFlg
        };
      } else if (Object.prototype.hasOwnProperty.call(this.$route.query, 'sameSystemFlg')) {
        info.query = {
          sameSystemFlg: this.$route.query.sameSystemFlg
        };
      }

      // 特殊機能一覧ページにリダイレクト
      this.$router.push(info);
      return;
    }

    // タブ制御
    this.$emit("setVehicleTabsAvailable", true);
    this.updateDTCTable();
  },

};
